/**
 * Форматирует дату в формат ДД.ММ.ГГГГ
 * @param date - Дата в формате string или Date
 * @returns Отформатированная строка с датой в формате ДД.ММ.ГГГГ
 */
export const formatDate = (date: string | Date | null | undefined): string => {
  if (!date) return '-';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '-';
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}.${month}.${year}`;
};